import { render, staticRenderFns } from "./StockRegistDialog.vue?vue&type=template&id=487fcdf0&scoped=true&"
import script from "./StockRegistDialog.vue?vue&type=script&lang=js&"
export * from "./StockRegistDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487fcdf0",
  null
  
)

export default component.exports